import MainLayout from '@/components/layout/MainLayout.vue';

export default {
    name: 'policy',

    components: {
        MainLayout,
    },
}
